module.exports = __webpack_public_path__ + "static/media/4.d61e7439.png";